var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xtkj webWrap"},[_c('div',{staticClass:"webCont"},[_c('div',{staticClass:"indexTitle"},[_c('p',[_vm._v("系统框架")]),_c('span')]),_c('img',{staticClass:"wow animate__fadeInUp",attrs:{"src":"static/lvya/nhsfz/xtkj.png","alt":""}})])])
}]

export { render, staticRenderFns }